export default "__VITE_ASSET__DMauBpbH__"